"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.application = void 0;
var application_src_1 = require("./application.src");
Object.defineProperty(exports, "application", { enumerable: true, get: function () { return application_src_1.application; } });



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/application/application.controls.tsx
// module id = 570
// module chunks = 0